import { useState, useCallback } from 'react';
import { apiClient } from '../api/client';

export interface InviteLink {
  url: string;
  domain: string;
  expires_at: string;
}

export interface InviteLinkPlan {
  included_users: number;
  current_members: number;
  billing_exempt: boolean;
}

/** Link de convite (com restrição de domínio) da organização ativa — só admin/owner. */
export function useInviteLink() {
  const [link, setLink] = useState<InviteLink | null>(null);
  const [plan, setPlan] = useState<InviteLinkPlan | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchLink = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await apiClient.get<{ link: InviteLink | null; plan: InviteLinkPlan }>('/orgs/me/invite-link');
      setLink(data.link);
      setPlan(data.plan);
    } finally {
      setIsLoading(false);
    }
  }, []);

  const generateLink = async (domain: string, expiresInHours: number, confirmExtraCharges: boolean) => {
    const data = await apiClient.post<{ link: InviteLink }>('/orgs/me/invite-link', {
      domain,
      expires_in_hours: expiresInHours,
      confirm_extra_charges: confirmExtraCharges,
    });
    setLink(data.link);
    return data.link;
  };

  const revokeLink = async () => {
    await apiClient.delete('/orgs/me/invite-link');
    setLink(null);
  };

  return { link, plan, isLoading, fetchLink, generateLink, revokeLink };
}
